<template>
  <div class="events">
    <template v-if="project != null">
      <div class="event" v-for="(event, index) in project.events" :key="event.id">        
        <Event :project="project" :events="project.events" :event="event" :index="index"/>
      </div>              
    </template>
  </div>
</template>

<script>
  import Event from './Event.vue'
  export default {
    props: {
      project: {
        type: Object,
        default: null
      }
    },
    components: {
      Event,
    },
  }
</script>

<style scoped>

</style>